import React from 'react';
import { Heading } from '../components/common/atoms'
import MFAMethod from '../components/common/templates/Login/MFAMethod'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { appApi } from '../services';
import { message } from 'antd';

const SettingsMFAMethodPage = () => {
  const history = useHistory()

  const methodSelected =  (e, type) => {
    if(type === 'app') fetchAuth('mfaQRAuth', 'mfa-qr')
    else  fetchAuth('mfaOTPAuth', 'mfa-otp')
  }

  const fetchAuth = async (method, pathname) => {
    const options = {}
    await appApi[method](options,
      (res)=>{
          history.push({pathname: pathname, state: res.data})
      },
      _=>{
        message.error('Something went wrong!')
      }
      );
  }

  return (
    <div>
      <div>
        <Heading mainHeading='Account Settings' subClasses='mt-1 text-sm text-gray-600' />
      </div>
      <div className='rounded-md shadow-md my-4 bg-white px-4 py-4' style={{width: '26rem'}}>
        <MFAMethod  methodSelect={methodSelected} history={history} account_setting={true} />
      </div>
    </div>

  )
}

export default SettingsMFAMethodPage